module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[93]92.394e54f.woff2";